export const environment = {
  production: false,
  // /*<-------- SIT Endpoints ---------> */
  //  APIEndpoint: 'https://tsb-sit-api.reciproci.com/',
  //  PG_CALLBACK_URL: 'https://tsb-sit.reciproci.com/',
  //  GM_API_KEY: 'AIzaSyAU-4dJvQP0uRvvLCyGUuSP-0shA_uVOUk',
  /*<-------- UAT Endpoints ---------> */
  
// APIEndpoint: 'https://tsb-mbaas-uat.starbucksindia.net/',
//   PG_CALLBACK_URL: 'http://localhost:4200/',
//   PG_CALLBACK_URL: 'https://kiosk.starbucksindia.net/',
//  GM_API_KEY: 'AIzaSyAU-4dJvQP0uRvvLCyGUuSP-0shA_uVOUk',
  // APIEndpoint: 'https://tsb-mbaas-uat.starbucksindia.net/',
  // PG_CALLBACK_URL: 'https://tsb-sit.reciproci.com/',
  // GM_API_KEY: 'AIzaSyAU-4dJvQP0uRvvLCyGUuSP-0shA_uVOUk',
 /*<-------- Pre-prod Endpoints ---------> */
//  APIEndpoint:'https://tsb-mbaas-uat-preprod.starbucksindia.net/',
// //PG_CALLBACK_URL: 'https://tsb-web-uat-preprod.starbucksindia.net/',
//  PG_CALLBACK_URL: 'http://localhost:4200/',
//  //PG_CALLBACK_URL: '192.168.1.12:4200/',
//   GM_API_KEY: 'AIzaSyAU-4dJvQP0uRvvLCyGUuSP-0shA_uVOUk',
  /*<-------- Production Endpoints ---------> */
   APIEndpoint:'https://tsb-mbaas.starbucksindia.net/',
   PG_CALLBACK_URL: 'https://kiosk.starbucksindia.net/',
   GM_API_KEY: 'AIzaSyAU-4dJvQP0uRvvLCyGUuSP-0shA_uVOUk',
  /*<-------- UAT firebase configuration ---------> */
  //   messagingSenderId: "906865248324",
  //   appId: "1:906865248324:web:d59e9dd0fdaf6830411411",
  //   measurementId: "G-V7Z5WXLJP1"
  // }
  /*<------- preprod firebase configuration ---------> */
  // firebase: {
  //   apiKey: "AIzaSyAOtqZbEwjOWUVYSOQh8uIPk44ZOv9zR2I",
  //   authDomain: "tata-starbucks-uat.firebaseapp.com",
  //   projectId: "tata-starbucks-uat",
  //   storageBucket: "tata-starbucks-uat.appspot.com",
  //   messagingSenderId: "906865248324",
  //   appId: "1:906865248324:web:2cc9a11d34fbbe97411411",
  //   measurementId: "G-ZE2YTTLJGN"
  // },
  /*<-------- Production firebase configuration ---------> */
  firebase: {
    apiKey: "AIzaSyAfjxEuT6QXM22X9f8NuTO0th1TVdFTIuQ",
    authDomain: "tata-starbucks-prod-40042.firebaseapp.com",
    projectId: "tata-starbucks-prod-40042",
    storageBucket: "tata-starbucks-prod-40042.appspot.com",
    messagingSenderId: "484743682779",
    appId: "1:484743682779:web:e1d108e9886bb2ad2f8afe",
    measurementId: "G-WGW68DB90J"
  },
  char: [116, 66, 72, 116, 74, 98, 99, 99, 83, 98, 104, 84, 98, 66, 113, 85]

};
